import Vue from 'vue'
import configs from '@/config'

const actions = {
  getToken: { method: 'GET', url: `${configs.baseUrl}/api/referral/token` },
  getRewardStatus: { method: 'GET', url: `${configs.baseUrl}/api/referral/reward-status` },
  acknowledgeReward: { method: 'POST', url: `${configs.baseUrl}/api/referral/reward-ack` },
}

let resource = null

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getToken = async () => {
  const res = await resource.getToken()
  return res.body
}

const getRewardStatus = async () => {
  const res = await resource.getRewardStatus()
  return res.body
}

const acknowledgeReward = async () => {
  const res = await resource.acknowledgeReward({})
  return res.body
}

export default {
  initResource, getToken, getRewardStatus, acknowledgeReward,
}
